module.exports = __webpack_public_path__ + "img/register_banner_companies.07d7c942.svg";